module.exports = __webpack_public_path__ + "img/02-cnn-cover.c9d52fef.png";